/**
 * @flow
 * @relayHash fbdacb2bf50c126592c921922bebf3e7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DownloadBatchReviewAssetsFilesInput = {|
  ids: $ReadOnlyArray<?string>,
  clientMutationId?: ?string,
|};
export type DownloadBatchReviewAssetsMutationVariables = {|
  input: DownloadBatchReviewAssetsFilesInput
|};
export type DownloadBatchReviewAssetsMutationResponse = {|
  +downloadBatchReviewAssetsFiles: ?{|
    +email: ?boolean
  |}
|};
export type DownloadBatchReviewAssetsMutation = {|
  variables: DownloadBatchReviewAssetsMutationVariables,
  response: DownloadBatchReviewAssetsMutationResponse,
|};
*/


/*
mutation DownloadBatchReviewAssetsMutation(
  $input: DownloadBatchReviewAssetsFilesInput!
) {
  downloadBatchReviewAssetsFiles(input: $input) {
    email
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DownloadBatchReviewAssetsFilesInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "downloadBatchReviewAssetsFiles",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DownloadBatchReviewAssetsFilesPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "email",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DownloadBatchReviewAssetsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DownloadBatchReviewAssetsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DownloadBatchReviewAssetsMutation",
    "id": null,
    "text": "mutation DownloadBatchReviewAssetsMutation(\n  $input: DownloadBatchReviewAssetsFilesInput!\n) {\n  downloadBatchReviewAssetsFiles(input: $input) {\n    email\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66a8bd16f1403e8ccbdc7f34019aeaf2';
module.exports = node;
